import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TestInstructionDialogComponent } from '../test-instruction-dialog/test-instruction-dialog.component';

@Component({
  selector: 'app-start-test-dialog',
  templateUrl: './start-test-dialog.component.html',
  styleUrls: ['./start-test-dialog.component.css']
})
export class StartTestDialogComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<StartTestDialogComponent>) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(true);
  }
  
  startTest() {
    this.dialog.open(TestInstructionDialogComponent, { width:'768px', panelClass: 'test-instruction-modal' });
    this.dialogRef.close(true);
  }

}
